/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { IEventRegAppProps, IinitialState, StepConstants, ISharedData, IUserSelections,  } from '../models/event-reg-refresh-models'
import { Header } from './header'
import { EventRegRefreshProvider } from '../reducers/event-reg-refresh-reducers'
import { Steps } from './steps'
import { calculateVisitedSteps, splitLocationInput } from '../helpers/helpers'

const EventRegistrationRefreshApp = ({epiProps, eventRegistrationRefreshModel } : IEventRegAppProps) => {

  // Check for shared selections from window.bootstrap
  const getSharedData = (): ISharedData | null => {
    try {
      // @ts-ignore - window.bootstrap is set by server
      const bootstrap = window.bootstrap;
      if (bootstrap && bootstrap.sharedUserSelections && bootstrap.sharedCurrentStep) {
        const sharedUserSelections = bootstrap.sharedUserSelections as IUserSelections;
        const sharedCurrentStep = bootstrap.sharedCurrentStep;
        return { sharedUserSelections, sharedCurrentStep };
      }
    } catch (error) {
      console.error('Failed to parse shared selection data:', error);
    }
    return null;
  };

  const sharedData = getSharedData();

  // Add programType=directdelivery query string if shared selection is direct delivery
  if (sharedData?.sharedUserSelections?.userProgramSelection?.isDirectDelivery) {
    const url = new URL(window.location.href);
    url.searchParams.set('programtype', 'directdelivery');
    window.history.replaceState({}, '', url.toString());
  }

  // Add programType=Renewal query string if shared selection is a renewal
  if (sharedData?.sharedUserSelections?.userProgramSelection?.isRenewal) {
    const url = new URL(window.location.href);
    url.searchParams.set('programtype', 'Renewal');
    window.history.replaceState({}, '', url.toString());
  }

  const defaultUserSelections: IUserSelections = {
    userProgramSelection: {
      programName: '',
      programCode: '',
      isRenewal: false,
      isDirectDelivery: false
    },
    userAddOnProgramSelections: [],
    userProgramDateTimeSelection: {
        culture: '',
        eventDates: '',
        eventNumber: '',
        facility: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        zip: '',
        timeZone: '',
        spokenLanguage: '',
        seatSku: '',
        qualification: '',
        isVirtual: false,
        isBlended: false,
        isFull: false,
        isFuture: false,
        days: [],
        price: 0,
        startDate: '',
        endDate: ''
    },
    userAddOnProgramDateTimeSelection: {
        culture: '',
        eventDates: '',
        eventNumber: '',
        facility: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        zip: '',
        timeZone: '',
        spokenLanguage: '',
        seatSku: '',
        qualification: '',
        isVirtual: false,
        isBlended: false,
        isFull: false,
        isFuture: false,
        days: [],
        price: 0,
        startDate: '',
        endDate: ''
    },
    attendees: [],
    filters: {
      cityState: '',
      postalCode: '',
      rangeInput: '',
      selectedDates: [],
      sortByDate: true
    }
  };

  // Shared links created before City/State and Zip were split only have `locationInput`.
  // Split that into cityState/postalCode so those links still restore the location filter.
  const sharedFilters = sharedData?.sharedUserSelections?.filters;
  const hasSplitLocationFields = sharedFilters?.cityState !== undefined || sharedFilters?.postalCode !== undefined;
  const splitLocationFields = sharedFilters && !hasSplitLocationFields
    ? splitLocationInput(sharedFilters.locationInput)
    : null;

  const mergedUserSelections: IUserSelections = sharedData?.sharedUserSelections
    ? {
        ...defaultUserSelections,
        ...sharedData.sharedUserSelections,
        filters: {
          ...defaultUserSelections.filters,
          ...sharedFilters,
          ...splitLocationFields
        }
      }
    : defaultUserSelections;

  const initialState: IinitialState = {
    epiProps: epiProps,
    eventRegistrationRefreshModel: eventRegistrationRefreshModel,
    currentStep: sharedData?.sharedCurrentStep || StepConstants.ProgramStep,
    visitedSteps: sharedData?.sharedCurrentStep
      ? calculateVisitedSteps(sharedData.sharedCurrentStep)
      : [StepConstants.ProgramStep],
    hideAttendeesStep: eventRegistrationRefreshModel.showPrice == false, //International users (outside US+CA) cannot see price or complete purchase. They do not need to fill out the attendees step.
    userSelections: mergedUserSelections,
    showOnlySharedProgramDateTimeSelection: sharedData?.sharedUserSelections?.userProgramDateTimeSelection?.eventNumber ? true : false,
    showOnlySharedAddOnProgramDateTimeSelection: sharedData?.sharedUserSelections?.userAddOnProgramDateTimeSelection?.eventNumber ? true : false,
    sharedProgramDateTimeEvent: sharedData?.sharedUserSelections?.userProgramDateTimeSelection || null,
    sharedAddOnProgramDateTimeEvent: sharedData?.sharedUserSelections?.userAddOnProgramDateTimeSelection || null
  }

  return (
    <EventRegRefreshProvider initialState={initialState}>
      <div>
          <Header />
        <Steps />
      </div>
    </EventRegRefreshProvider >

  )
}

export default EventRegistrationRefreshApp
